import React from 'react'
import { Link } from "react-scroll";

export default function Hero1() {
  return (
    <section id='inicio' className='hero-section'>
      <div className="min-h-screen bg-hero-pattern">
        <div className="overlay min-h-screen flex items-center justify-center">
          <div className="content-wrapper text-center px-4 md:px-8 py-16">
            <div className="mx-auto" style={{marginTop:'-5rem'}}>
              <div className='GEI' style={{display:'flex', justifyContent:'center',marginBottom:'1rem'}}>
              GEI
              </div>
              
              <h1 style={{fontSize:'3rem'}} className="  font-bold  mb-6">
              Gases de Efecto Invernadero              </h1>
              <h2 style={{marginBottom:'4rem'}} className=" nobile mb-6">
              Nuestra plataforma utiliza inteligencia artificial avanzada para ayudarte a gestionar tu impacto ambiental de manera inteligente y efectiva.
              </h2>
              <div className="div-btn-hero">
              <a style={{fontSize:'1.5rem'}}
                target='_blank'
                href="https://chat.gei.cl/"
                smooth={true}
                duration={500}
                offset={-70}
                className="btn btn-primary w-full md:w-auto cursor-pointer"
              >
                Prueba nuestro Chatbot Beta
              </a>
              <Link style={{fontSize:'1.5rem'}}
                to="servicios"
                smooth={true}
                duration={500}
                offset={-70}
                className="btn btn-contacto w-full md:w-auto cursor-pointer verde"
              >
                Saber más
              </Link>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
